import { Branding, BrandingDisabledIf, DisabledPrompt, useModel, useRoute } from "bcms-react";
import Util from "classes/Util";
import { SVGAsset } from 'res';
import { MobileNavItem, MobileNavMenuItem, MobileNavDropdownMenuItem } from "../..";

/**
 * @function BID932MobileNavItems
 * @extends React.Component
 * @exported true
 * @description The main component for navigation for BID 126 in mobile.
 * @example
   <BID932MobileNavItems links={{
    profile: profileItem,
    settings: settingsItem
   }}/>
 */
export default function BID932MobileNavItems(props) {
    const { demos, branding } = useModel();
    const navigate = useRoute();
    const paymentsLabel = "Payments";
    const items = props.items ?? {}; 

    const openAccount = evt => {
        if(Util.inMabi) {
            window.parent.postMessage({ message:"force-global-route", detail: {
                route: `/content/orig`
            }   
            }, "*");
        } else {
            let origVersion = branding.options.orig_version_abi22;
            if(origVersion !== "ORIG19") origVersion = "ORIG20";
            window.open(demos[origVersion], "_blank");
        }
    }

    const newAccountsItem = <MobileNavDropdownMenuItem className="accounts-mobile-link" itemIcon={<SVGAsset id="WalletIcon" />} label="Accounts" dataPoint="Nav_Accounts">
                                <MobileNavMenuItem className="account-summary-mobile-link" to="/accountSummary" label="Account Summary" dataPoint="Nav_Account_Summary" />      
                                <MobileNavMenuItem className="eDocument-preference-link" to="/statementPreference" label="eDocument Preference" dataPoint="Nav_ePreference" />
                                <MobileNavMenuItem className="stop-payments-mobile-link" to="/stopPayment" label="Stop Payment" dataPoint="Nav_Stop_Payments" />
                                <DisabledPrompt>
                                    <MobileNavMenuItem className="open-an-account-mobile-link" label="Open an Account" dataPoint="Nav_Open_Account" />
                                </DisabledPrompt>
                                <MobileNavMenuItem className="credit-score-link" to="/creditScore" label="Credit Score" dataPoint="Nav_Credit_Score" />
                                { !Util.inMabi && 
                                    <MobileNavMenuItem className="download-transaction-history-link" label="Download" to="/download" dataPoint="Nav_Download" />
                                }
                                <MobileNavMenuItem className="my-accounts-mobile-link" to="/statements" label="E-Statements & Notices" dataPoint="Nav_eStatements_Noticies" />
                            </MobileNavDropdownMenuItem>;

    const zelleItem = <MobileNavItem className="zelle-mobile-link" itemIcon={ <SVGAsset id="ZelleIcon" /> } label={<>Zelle<span className="r-mark">&reg;</span></>} to="/zelle/RXP17/zelle" dataPoint="Nav_Zelle" />

    const paymentsItem = <MobileNavItem className="rxpmw-mobile-link" itemIcon={ <SVGAsset id="DollarSignOutlineIcon" /> } label={ paymentsLabel } to="/rxpmw" dataPoint="Nav_Payments" />

    const transfersItem = <MobileNavDropdownMenuItem className="transfer-mobile-link"  itemIcon={<SVGAsset id="TransfersIcon" />}label="Transfers" dataPoint="Nav_Transfers">
                            <MobileNavMenuItem className="make-a-transfer-mobile-link" to="/transfers" label="Make a Transfer" dataPoint="Nav_Make_Transfer" />
                            <MobileNavMenuItem className="transfer-activity-mobile-link" to="/transferActivity/scheduledTransfers" label="Transfer Activity" dataPoint="Nav_Transfer_Activity" />
                            <Branding id="tn19_abi22" value="true">
                                <BrandingDisabledIf id="tn19_courseID_abi22" exp={ value => value !== null }>
                                    <MobileNavMenuItem className="external-transfers-mobile-link" label="External Transfers" to="/externalTransfers" dataPoint="Nav_External_Transfers" />
                                </BrandingDisabledIf>
                            </Branding>
                            <MobileNavMenuItem className="transfer-activity-mobile-link" to="/unlinkedTransferAccounts" label="Customer Transfer" dataPoint="Nav_Transfer_Accounts" />    
                        </MobileNavDropdownMenuItem>

const debitCardsItem = <BrandingDisabledIf id="ch21_courseid_abi22" exp={ value => value !== undefined && value !== null }>
                            <MobileNavItem className="ch21-mobile-link" itemIcon={ <SVGAsset id="CardIcon" /> } label="Cards" to="/ch21" dataPoint="Nav_Cards" />
                        </BrandingDisabledIf>

const depositItems = <>{ Util.inMabi &&  
                        <MobileNavDropdownMenuItem className="deposits-mobile-link"  itemIcon={<SVGAsset id="CameraIcon" />} label="Deposits" dataPoint="Nav_Deposits">
                            <MobileNavMenuItem to="/depositACheckWorkflow" label="Deposit a Check" dataPoint="Nav_Deposit_A_Check" />
                            <MobileNavMenuItem className="deposit-history-link"  to="/depositHistory" label="Mobile Deposit History" dataPoint="Nav_Deposit_History" />
                        </MobileNavDropdownMenuItem> 
                    }</>
                   

const myBudgetItem = <MobileNavItem className="pfm21-mobile-link" itemIcon={ <SVGAsset id="PiggyBankDollarSignIcon" /> } label="My Budget" to="/myFinances" dataPoint="Nav_My_Finances" />;


const alertsItem = <BrandingDisabledIf id="notifi_version_abi22"  exp={(val) => val !== "Disabled" }>       
                            <Branding id="alerts_abi22" value="true">
                                <MobileNavItem className="alerts-mobile-link" to="/notifications" itemIcon={ <SVGAsset id="BellIcon" /> } label="Alerts" dataPoint="Utility_Alerts" />
                            </Branding>
                    </BrandingDisabledIf>;

const profileItem = <MobileNavDropdownMenuItem className="profile-mobile-link" itemIcon={ <SVGAsset id="CircleProfileIcon" /> } label="Profile" dataPoint="Utility_Profile">
                        <MobileNavMenuItem className="email-mobile-link" to="/email" label="Email Address" dataPoint="Utility_Email" />
                        <MobileNavMenuItem className="phone-mobile-link" to="/phoneNumber" label="Phone" dataPoint="Utility_Phone" />
                        <MobileNavMenuItem className="scheduled-transfers-mobile-link" to="/password" label="Password" dataPoint="Utility_Password" />
                        <MobileNavMenuItem className="user-id-mobile-link" label="User ID" to="/userId" dataPoint="Nav_User_ID" />
                        <MobileNavMenuItem className="stopped-numbers-mobile-link" to="/stoppedNumbers" label="Stopped Phone Numbers" dataPoint="Nav_Stopped_Numbers" />
                        <DisabledPrompt>
                            <Branding id="tax_documents_abi22" value="true" default="false">
                              <MobileNavMenuItem className="tax-documents-mobile-link" label="Tax Documents" route="/taxDocuments" dataPoint="Utility_Tax_Documents"  />
                            </Branding>
                        </DisabledPrompt> 
                    </MobileNavDropdownMenuItem>;

const settingsItems = <MobileNavDropdownMenuItem className="settings-mobile-link"  itemIcon={<SVGAsset id="GearIcon" />} label="Settings" dataPoint="Utility_Settings">
                        { Util.inMabi && 
                        <MobileNavMenuItem className="authorized-device-enrollment-mobile-link" to="/authorizedDeviceEnrollmentWorkflow" label="Authorized Device Enrollment" dataPoint="Utility_Authorized_Device_Enrollment" /> 
                        }
                        <MobileNavMenuItem className="authorized-device-enrollment-mobile-link" to="/authorizedDevicesWorkflow" label="Authorized Devices" dataPoint="Utility_Authorized_Devices" />
                        <Branding id="instant_balances_abi22" value="true">
                            <MobileNavMenuItem className="fast-balances-mobile-link" to="/settingsFastBalancesWorkflow" label="Fast Balance" dataPoint="Utility_Instance_Balances" />
                        </Branding>
                        <Branding id="secure_forms_abi22" value="true" default="true">
                            <MobileNavMenuItem className="secure-forms-mobile-link" to="/secureforms" label="Secure Forms" dataPoint="Utility_Secure_Forms" />
                        </Branding>
                        <MobileNavMenuItem className="user-activity-mobile-link" to="/userActivityWorkflow" label="User Activity" dataPoint="Utility_User_Activity" />
                        <MobileNavMenuItem className="accepted-disclosures-mobile-link" to="/acceptedDisclosuresWorkflow" label="Accepted Disclosures" dataPoint="Utility_Accepted_Disclosures" />
                        <Branding id="delete_an_account_abi22" value="true" default="true">
                            <DisabledPrompt>
                              <MobileNavMenuItem className="delete-an-account-mobile-link" to="/deleteanaccount" label="Delete an Account" dataPoint="Utility_Delete_Account" />
                            </DisabledPrompt>
                        </Branding>
                        { !Util.inMabi && 
                            <MobileNavMenuItem className="deposit-history-link"  to="/depositHistory" label="Mobile Deposit History" dataPoint="Nav_Deposit_History" />
                        }
                        
                    </MobileNavDropdownMenuItem>;

const messagesItem = <MobileNavItem className="messages-mobile-link" to="/messages" label="Messages" itemIcon={<SVGAsset id="EnvelopeIcon" />} dataPoint="Nav_Messages">
                        <div className="set-width alert-bubble flex-container all-center">
                            <span>3</span>
                        </div>
                    </MobileNavItem>;

   

  return (
   <Branding id="bid_abi22" value="932" >
          { newAccountsItem }
          { transfersItem }
          { paymentsItem }
          { zelleItem }
          { debitCardsItem }
          { depositItems }
          { myBudgetItem }
          { alertsItem }
          { profileItem }
          { settingsItems }
          { messagesItem }
     </Branding>
  );
}

